import React from "react";

import { ReactComponent as EditIcon } from "assets/img/svg/Edit2.svg";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper.jsx";
import AButton from "../../common/form-fields-mui/AButton";

const ActionsCell = ({
  params,
  handleEditClick,
  handleCancelClick,
  handleSaveClick,
  rowForm,
}) => {
  return params.api.getRowMode(params?.id) === "view" ? (
    <>
      <div className="d-flex align-items-center">
        <IconButtonWrapper onClick={() => handleEditClick(params)}>
          <EditIcon />
        </IconButtonWrapper>
      </div>
    </>
  ) : (
    <div className="d-flex align-items-center">
      <AButton
        variant="primary_filled"
        size="xs"
        onClick={(event) => {
          handleSaveClick(params);
          event.target.disabled = true;
        }}
        disabled={
          !rowForm?.phaseName ||
          !rowForm?.academicGroup ||
          !rowForm?.crct ||
          !rowForm?.toDate ||
          !rowForm?.fromDate
        }
      >
        Save
      </AButton>
      <IconButtonWrapper
        className="ml-1"
        onClick={() => handleCancelClick(params)}
      >
        <CrossIcon />
      </IconButtonWrapper>
    </div>
  );
};

export default ActionsCell;
